export default "__VITE_ASSET__CwuBnsl___"